/**
 * @generated SignedSource<<18adef06a11ad10165b8c2c0d87b0b8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCreateMainNewQuery$variables = {
  categoryId: string;
  productIds: ReadonlyArray<string>;
  teamIds: ReadonlyArray<string>;
};
export type TodoCreateMainNewQuery$data = {
  readonly currentStore: {
    readonly me: {
      readonly employee: {
        readonly id: string;
      } | null;
    } | null;
  } | null;
  readonly storeProductsByIds: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"AttachedContent_products">;
  } | null> | null;
  readonly todoCategory: {
    readonly tags: ReadonlyArray<{
      readonly color: string;
      readonly id: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTags_tags">;
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TodoCreateToolbar_data">;
};
export type TodoCreateMainNewQuery = {
  response: TodoCreateMainNewQuery$data;
  variables: TodoCreateMainNewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v3 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "productIds"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "categoryId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCreateMainNewQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "TodoCreateToolbar_data"
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "StoreProduct",
        "kind": "LinkedField",
        "name": "storeProductsByIds",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AttachedContent_products"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "TodoCategory",
        "kind": "LinkedField",
        "name": "todoCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategoryTag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TodoToolbarButtonTags_tags"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoCreateMainNewQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "ids",
            "variableName": "teamIds"
          }
        ],
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamsByIds",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v9/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPrivate",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "StoreProduct",
        "kind": "LinkedField",
        "name": "storeProductsByIds",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partNumber",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "TodoCategory",
        "kind": "LinkedField",
        "name": "todoCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategoryTag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "817246eca9377c34e6225e19c16586a5",
    "id": null,
    "metadata": {},
    "name": "TodoCreateMainNewQuery",
    "operationKind": "query",
    "text": "query TodoCreateMainNewQuery(\n  $categoryId: ID!\n  $teamIds: [ID!]!\n  $productIds: [ID!]!\n) {\n  ...TodoCreateToolbar_data\n  storeProductsByIds(ids: $productIds) {\n    ...AttachedContent_products\n    id\n  }\n  todoCategory(id: $categoryId) {\n    tags {\n      id\n      title\n      color\n      ...TodoToolbarButtonTags_tags\n    }\n    id\n  }\n  currentStore {\n    me {\n      employee {\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment AttachedContent_products on StoreProduct {\n  id\n  name\n  ...LinkedStoreProductItem_StoreProduct\n}\n\nfragment LinkedStoreProductItem_StoreProduct on StoreProduct {\n  id\n  imageUrl\n  partNumber\n  name\n}\n\nfragment TodoCreateToolbar_data on Query {\n  teamsByIds(ids: $teamIds) {\n    ...TodoToolbarButtonTeams_teams\n    id\n  }\n}\n\nfragment TodoTagButtonContentActive_todoCategoryTag on TodoCategoryTag {\n  id\n  title\n  color\n}\n\nfragment TodoToolbarButtonTags_tags on TodoCategoryTag {\n  ...TodoTagButtonContentActive_todoCategoryTag\n}\n\nfragment TodoToolbarButtonTeamsDetail_teams on Team {\n  id\n  ...AHTeamIconCircle\n}\n\nfragment TodoToolbarButtonTeams_teams on Team {\n  id\n  name\n  ...TodoToolbarButtonTeamsDetail_teams\n}\n"
  }
};
})();

(node as any).hash = "284248523f8e51a4f7e0f9cefc9b325e";

export default node;
